<template>
  <div class="transfer">
    <v-app>
      <div v-if="!userid">
        <v-container>
          <v-alert :value="true" color="warning" icon="priority_high" outline>{{
            $t('Not found this page')
          }}</v-alert>
        </v-container>
      </div>
      <div v-else-if="isCompleted">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart@4x.png"
              alt="shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">{{ $t('Payment Successfully') }}</p>
            <v-btn outline :color="theme.color" @click="goToShop()">{{
              $t('Continue Shopping')
            }}</v-btn>
          </div>
        </cover>
      </div>
      <!-- <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="margin-left: -93px;text-align: center;margin-top: -95px;">
            <img
              src="../assets/img/ecommerce/empty_shopping_cart@4x.png"
              alt="empty shopping cart"
              style="width: 140px;padding-bottom: 10px;"
            >
            <p style="padding-bottom: 10px">{{$t('There are no items in this cart')}}</p>
            <v-btn
              outline
              :color="theme.color"
              @click="goToShop()"
            >{{$t('Continue Shopping')}}</v-btn>
          </div>
        </cover>
      </div>-->
      <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart_out@4x.png"
              alt="empty shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">
              {{ $t('This order has been reset, please try to order again.') }}
            </p>

            <v-btn outline :color="theme.color" @click="goToShop()">{{
              $t('Continue Shopping')
            }}</v-btn>
          </div>
        </cover>
      </div>
      <!-- <div v-else-if="pageLoading" style="height: 100vh">
        <v-layout justify-center align-center style="height: 100%">
          <v-progress-circular
            :key="theme.color"
            :size="70"
            :width="7"
            :color="theme.color"
            indeterminate
          ></v-progress-circular>
        </v-layout>
      </div>-->
      <div v-else>
        <merchant-detail v-model="pageProfile"></merchant-detail>

        <form
          id="checkout-form"
          class="checkout-form"
          method="POST"
          @submit.prevent="handleSubmit"
        >
          <v-container class="mt-5">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <h3 class="headline" :style="{ color: theme.color }">
                  {{ $t('Payment') }}
                </h3>
                <br />
              </v-flex>
              <v-flex xs12 sm6 offset-sm3>
                <div
                  :class="{ 'has-error': errors.has('customerName') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('Name')"
                    :data-vv-as="$t('Name')"
                    outline
                    name="customerName"
                    v-validate="'required'"
                    v-model="customerName"
                    light
                    :color="theme.color"
                    :error="errors.has('customerName') ? true : false"
                    :error-messages="
                      errors.has('customerName')
                        ? errors.first('customerName')
                        : ''
                    "
                  ></v-text-field>
                </div>
                <div
                  v-if="isOoca"
                  :class="{ 'has-error': errors.has('emailAddress') }"
                  class="mb-1"
                >
                  <v-text-field
                    outline
                    :label="$t('Email Address')"
                    name="emailAddress"
                    rows="5"
                    :data-vv-as="$t('Email Address')"
                    style="resize: none; width: 100%"
                    v-model="shippingAddress"
                    v-validate="{ required: true, email: true }"
                    light
                    :color="theme.color"
                    :error="errors.has('emailAddress') ? true : false"
                    :error-messages="
                      errors.has('emailAddress')
                        ? errors.first('emailAddress')
                        : ''
                    "
                  ></v-text-field>
                </div>
                <div
                  v-else
                  :class="{ 'has-error': errors.has('shippingAddress') }"
                  class="mb-1"
                >
                  <v-textarea
                    outline
                    :label="$t('Shipping Address')"
                    :placeholder="
                      $t('Ex. Address No., Village, Alley, and Road')
                    "
                    name="shippingAddress"
                    rows="5"
                    :data-vv-as="$t('Shipping Address')"
                    style="resize: none; width: 100%"
                    v-model="shippingAddress"
                    v-validate="{
                      required: true,
                      regex: /([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/,
                      isBearhousezipcode: [cart.length, isBearhouse]
                    }"
                    light
                    :color="theme.color"
                    :error="errors.has('shippingAddress') ? true : false"
                    :error-messages="
                      errors.has('shippingAddress')
                        ? errors.first('shippingAddress')
                        : ''
                    "
                  ></v-textarea>
                </div>

                <div
                  v-if="$store.state.cds.includes(pageid)"
                  :class="{ 'has-error': errors.has('remark') }"
                >
                  <v-text-field
                    outline
                    :label="$t('The 1 Card Number') + ` (${$t('Optional')})`"
                    name="remark"
                    :data-vv-as="$t('The 1 Card Number')"
                    style="resize: none; width: 100%"
                    v-model="remark"
                    :color="theme.color"
                    light
                  ></v-text-field>
                </div>

                <div
                  :class="{ 'has-error': errors.has('customerPhone') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('Tel.')"
                    :data-vv-as="$t('Tel.')"
                    outline
                    tyle="tel"
                    name="customerPhone"
                    light
                    :color="theme.color"
                    v-validate="{
                      required: true,
                      regex:
                        /((\(?(\+\s*)([0-9]{2,3})\)?\s*[0]?)|[0])(([1-9][0-9]?))\s*\-?\s*([0-9]{3})\s*\-?\s*([0-9]{4,5})/
                    }"
                    v-model="customerPhone"
                    :error="errors.has('customerPhone') ? true : false"
                    :error-messages="
                      errors.has('customerPhone')
                        ? errors.first('customerPhone')
                        : ''
                    "
                  ></v-text-field>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-container class="mt-3">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <!-- <div v-if="!(pageProfile.fbpay_status || pageProfile.gbprime_status)">
                  <div class="mb-4">
                    <template v-if="banktransferinfo_photo">
                      <img
                        :src="banktransferinfo_photo"
                        alt="bank transfer"
                        style="border:1px solid #eee; border-radius: 5px;margin-bottom: 15px; width: 100%"
                      />
                    </template>
                    <template v-if="banktransferinfo">
                      <bank-number :text="banktransferinfo"></bank-number>
                    </template>
                  </div>

                  <div
                    :class="{ 'has-error': errors.has('paymentSlipImage') }"
                    class="mb-4"
                    v-if="
                    !shippingType ||
                      (shippingType && shippingType.type != 'cod_charge')
                  "
                  >
                    <h3 class="headline" :style="{ color: theme.color }">{{ $t("Payment slip") }}</h3>
                    <br />

                    <upload-file
                      name="paymentSlipImage"
                      v-validate="'required'"
                      :data-vv-as="$t('Payment Slip Image')"
                      v-model="paymentSlipImage"
                    ></upload-file>
                    <p
                      class="caption ma-2"
                      style="color: red"
                      v-show="errors.has('paymentSlipImage')"
                    >{{ errors.first("paymentSlipImage") }}</p>
                  </div>
                </div>-->

                <div
                  v-if="!$store.state.cds.includes(pageid)"
                  :class="{ 'has-error': errors.has('remark') }"
                  style="margin-bottom: 15px"
                >
                  <v-textarea
                    outline
                    :label="$t('เลขบัญชี')"
                    name="remark"
                    rows="5"
                    :data-vv-as="$t('เลขบัญชี')"
                    style="resize: none; width: 100%"
                    v-model="remark"
                    :color="theme.color"
                    light
                  ></v-textarea>
                </div>
                <div>
                  <div style="padding-bottom: 25px">
                    <v-card>
                      <v-card-text>
                        <!-- Cash on Delivery -->
                        <template
                          v-if="
                            shippingType && shippingType.type == 'cod_charge'
                          "
                        >
                          <h3 class="text-xs-center">{{ $t('cod_charge') }}</h3>

                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t('By clicking Proceed Payment, Ive read and')
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <template v-if="loading">
                            <div class="text-xs-center my-3">
                              <v-progress-circular
                                :key="theme.color"
                                indeterminate
                                :color="theme.color"
                              ></v-progress-circular>
                            </div>
                          </template>
                          <template v-else>
                            <p
                              class="text-xs-center"
                              style="color: red"
                              v-if="isCartOutOfStock"
                            >
                              {{
                                $t(
                                  'Not enough products in stock, please try to order again.'
                                )
                              }}.
                            </p>
                            <div class="text-xs-center">
                              <v-btn
                                dark
                                :color="theme.color"
                                :disabled="loading || isCartOutOfStock"
                                @click="handleSubmit"
                                :loading="pageLoading"
                              >
                                <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                {{ $t('Proceed Payment') }}
                              </v-btn>
                            </div>
                          </template>
                        </template>
                        <template v-else>
                          <v-layout row wrap class="mb-3">
                            <v-flex
                              class="pr-1"
                              v-if="pageProfile.gbprime_status"
                              :style="{ width: showOnlyQRpage ? '100%' : '' }"
                            >
                              <div v-if="showOnlyQRpage" class="text-xs-center">
                                <v-icon small class="mr-2"
                                  >mdi-qrcode-scan</v-icon
                                >
                                <b>QR CODE</b>
                              </div>
                              <v-btn
                                v-else
                                :color="theme.color"
                                dark
                                block
                                small
                                @click="transferType = 'qrcode'"
                                :outline="transferType != 'qrcode'"
                              >
                                <v-icon small class="mr-2"
                                  >mdi-qrcode-scan</v-icon
                                >QR CODE
                              </v-btn>
                            </v-flex>
                            <v-flex class="pr-1">
                              <template v-if="hasPaymentMethodMoreThanOne">
                                <v-btn
                                  v-if="!showOnlyQRpage"
                                  :color="theme.color"
                                  dark
                                  block
                                  small
                                  @click="transferType = 'transfer'"
                                  :outline="transferType != 'transfer'"
                                >
                                  <v-icon small class="mr-2"
                                    >mdi-cash-multiple</v-icon
                                  >
                                  {{ $t('transfer') }}
                                </v-btn>
                              </template>
                              <template v-else>
                                <h3 class="text-xs-center">
                                  {{ $t('transfer') }}
                                </h3>
                              </template>
                            </v-flex>
                            <v-flex v-if="pageProfile.fbpay_status">
                              <v-btn
                                :color="theme.color"
                                dark
                                small
                                block
                                @click="transferType = 'fbpay'"
                                :outline="transferType != 'fbpay'"
                              >
                                <template
                                  v-if="$store.state.cds.includes(pageid)"
                                >
                                  <v-icon small class="mr-2"
                                    >mdi-credit-card</v-icon
                                  >{{ $t('Credit Cards') }}
                                </template>
                                <template v-else>
                                  <v-icon small class="mr-2"
                                    >mdi-cellphone-android</v-icon
                                  >
                                  {{ $t('Mobile Banking') }}
                                </template>
                              </v-btn>
                            </v-flex>
                            <v-flex
                              v-if="
                                shippinglist &&
                                shippinglist.hasOwnProperty('cod_charge') &&
                                shippinglist['cod_charge'][1]
                              "
                            >
                              <v-btn
                                :color="theme.color"
                                dark
                                small
                                block
                                @click="
                                  shippingType = {
                                    type: 'cod_charge',
                                    value: shippinglist['cod_charge'][0]
                                  }
                                "
                                :outline="transferType != 'cod_charge'"
                              >
                                <v-icon small class="mr-2"
                                  >mdi-package-variant-closed</v-icon
                                >
                                {{ $t('cod_charge') }}
                              </v-btn>
                            </v-flex>
                          </v-layout>

                          <template
                            v-if="['transfer', 'fbpay'].includes(transferType)"
                          >
                            <div v-if="['transfer'].includes(transferType)">
                              <div class="mb-4">
                                <template v-if="banktransferinfo_photo">
                                  <img
                                    :src="banktransferinfo_photo"
                                    alt="bank transfer"
                                    style="
                                      border: 1px solid #eee;
                                      border-radius: 5px;
                                      margin-bottom: 15px;
                                      width: 100%;
                                    "
                                  />
                                </template>
                                <template v-if="banktransferinfo">
                                  <bank-number
                                    :text="banktransferinfo"
                                  ></bank-number>
                                </template>
                              </div>

                              <div
                                :class="{
                                  'has-error': errors.has('paymentSlipImage')
                                }"
                                class="mb-4"
                                v-if="
                                  !shippingType ||
                                  (shippingType &&
                                    shippingType.type != 'cod_charge')
                                "
                              >
                                <h3
                                  class="headline"
                                  :style="{ color: theme.color }"
                                >
                                  {{ $t('Payment slip') }}
                                </h3>
                                <br />
                                <template v-if="!isCartOutOfStock">
                                  <upload-file
                                    name="paymentSlipImage"
                                    v-validate="'required'"
                                    :data-vv-as="$t('Payment Slip Image')"
                                    v-model="paymentSlipImage"
                                  ></upload-file>
                                </template>
                                <p
                                  class="caption ma-2"
                                  style="color: red"
                                  v-show="errors.has('paymentSlipImage')"
                                >
                                  {{ errors.first('paymentSlipImage') }}
                                </p>
                              </div>
                            </div>
                            <div
                              class="text-xs-center"
                              style="padding-top: 15px; padding-bottom: 15px"
                            >
                              <a
                                href="javascript:void(0);"
                                @click="openModal()"
                                style="color: rgb(169, 169, 169)"
                              >
                                {{
                                  $t(
                                    'By clicking Proceed Payment, Ive read and'
                                  )
                                }}
                                <br />
                                {{ $t('agree to') }}
                                <span :style="{ color: theme.color }">
                                  {{
                                    $t('Terms & Condition & Refund Prolicy')
                                  }} </span
                                >.
                              </a>
                            </div>
                            <template v-if="loading">
                              <div class="text-xs-center my-3">
                                <v-progress-circular
                                  :key="theme.color"
                                  indeterminate
                                  :color="theme.color"
                                ></v-progress-circular>
                              </div>
                            </template>
                            <template v-else>
                              <p
                                class="text-xs-center"
                                style="color: red"
                                v-if="isCartOutOfStock"
                              >
                                {{
                                  $t(
                                    'Not enough products in stock, please try to order again.'
                                  )
                                }}.
                              </p>
                              <div class="text-xs-center">
                                <v-btn
                                  dark
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="handleSubmit"
                                  :loading="pageLoading"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            <div
                              class="text-xs-center"
                              style="padding-top: 15px; padding-bottom: 15px"
                            >
                              <a
                                href="javascript:void(0);"
                                @click="openModal()"
                                style="color: rgb(169, 169, 169)"
                              >
                                {{
                                  $t(
                                    'By clicking Proceed Payment, Ive read and'
                                  )
                                }}
                                <br />
                                {{ $t('agree to') }}
                                <span :style="{ color: theme.color }">
                                  {{
                                    $t('Terms & Condition & Refund Prolicy')
                                  }} </span
                                >.
                              </a>
                            </div>

                            <template v-if="loading">
                              <div class="text-xs-center my-3">
                                <v-progress-circular
                                  :key="theme.color"
                                  indeterminate
                                  :color="theme.color"
                                ></v-progress-circular>
                              </div>
                            </template>
                            <template v-else>
                              <p
                                class="text-xs-center"
                                style="color: red"
                                v-if="isCartOutOfStock"
                              >
                                {{
                                  $t(
                                    'Not enough products in stock, please try to order again.'
                                  )
                                }}.
                              </p>
                              <div class="text-xs-center">
                                <v-btn
                                  dark
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="qrHandleSubmit"
                                  :loading="pageLoading || loadingQrcode"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                              </div>
                            </template>
                          </template>
                        </template>
                      </v-card-text>
                    </v-card>
                  </div>
                  <!--
                  <div v-else class="text-xs-center" style="padding-bottom: 25px">
                    <div style="padding-top:15px;padding-bottom:15px;">
                      <a
                        href="javascript:void(0);"
                        @click="openModal()"
                        style="color: rgb(169, 169, 169);"
                      >
                        {{ $t("By clicking Proceed Payment, Ive read and") }}
                        <br />
                        {{ $t("agree to") }}
                        <span :style="{ color: theme.color }">
                          {{
                          $t("Terms & Condition & Refund Prolicy")
                          }}
                        </span>.
                      </a>
                    </div>
                    <p class="text-xs-center" style="color: red;" v-if="isCartOutOfStock">
                      {{
                      $t(
                      "Not enough products in stock, please try to order again."
                      )
                      }}.
                    </p>
                    <v-btn
                      dark
                      :color="theme.color"
                      :disabled="loading || isCartOutOfStock"
                      @click="handleSubmit"
                      :loading="pageLoading "
                    >
                      <v-icon class="mr-2">mdi-cart-outline</v-icon>
                      {{ $t("Proceed Payment") }}
                    </v-btn>
                  </div>-->
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </div>
    </v-app>
    <Loading v-if="!pageLoading && loading"></Loading>
    <term-and-condition
      :pageid="pageProfile.pageid"
      v-if="showTerm"
      @close="close()"
    ></term-and-condition>
    <v-dialog v-model="showQrCode" max-width="376" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="closeQrCode">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <template v-if="qrimage">
            <img :src="qrimage" style="width: 100%" />
            <div class="text-xs-center mt-2">
              {{
                $t(
                  'If you already have proceeded a payment, you may close this popup window.'
                )
              }}
            </div>
            <!-- <div class="text-xs-center">
              <div>
                กรุณาจ่ายเงินภายใน
                <span :style="{color: theme.color}">{{timer}}</span> วินาที
                <br />หากแสกนแล้วโปรดรอซักครู่
                <br />ติดปัญหากรุณาติดต่อแอดมิน
              </div>
            </div>-->
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import $ from 'jquery'
import config from '@/config'
import axios from 'axios'
import nl2br from 'vue-nl2br'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'

import Loading from '@/components/Loading.vue'
import Modal from '@/components/Modal.vue'
import Cover from '@/components/Cover.vue'
import UploadFile from '@/components/UploadFile.vue'
import TermAndCondition from '@/components/ecommerce/TermAndCondition.vue'
import MerchantDetail from '@/components/ecommerce/MerchantDetail'
import CartItem from '@/components/payment/CartItem.vue'
import BankNumber from '@/components/BankNumber.vue'
import ShippingType from '@/components/ecommerce/ShippingType.vue'
import CartSummary from '@/components/ecommerce/CartSummary.vue'
import { bearhousecalculateshippingprice } from '@/assets/js/BearHouse.js'
import { shippingprice as cdsshippingprice } from '@/assets/js/Cds.js'
import moment from 'moment'
// import querystring from "querystring";
import numeral from 'numeral'

const dict = {
  en: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: 'Wrong shipping address'
      }
    }
  },
  th: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: 'ที่อยู่จัดส่งไม่ถูกต้อง'
      }
    }
  },
  la: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: 'ที่อยู่จัดส่งไม่ถูกต้อง'
      }
    }
  }
}

export default {
  data() {
    return {
      gbprime: {
        url: null,
        token: null,
        refno: null,
        backgroundUrl: null,
        amount: null
      },
      timestamp: moment().format('x'),
      app: 'facebook',
      pageid: null,
      userid: null,
      paiddate: null,
      paidtime: null,
      products: {},
      remark: '',
      transferType: '',

      additionalproduct_charge: 0,
      ems_charge: 0,
      normal_charge: 0,
      kerry_charge: 0,
      total: 0,
      totalincludediscount: 0,
      discount: 0,

      shippingType: undefined,

      loading: false,
      pageLoading: true,

      isCompleted: false,
      isEmptyShoppingCart: false,

      shippingAddress: null,
      showAlert: false,
      showProduct: false,
      shippinglist: undefined,
      showQrCode: false,
      qrimage: '',
      intervalQrCode: null,
      timer: 300,
      isRequest: true,
      referenceNo: '',

      config: {
        color: config.color
      },

      sessiontoken: null,
      banktransferinfo: null,
      banktransferinfo_photo: null,
      paymentSlipImage: null,

      showTerm: false,
      customerName: null,
      customerPhone: null,
      loadingQrcode: false,
      isCartOutOfStock: false
    }
  },
  mounted: async function () {
    let vm = this

    vm.$validator.localize(dict)
    vm.$validator.localize(this.currentLang)

    vm.loading = true

    if (vm.$route.query.userid) {
      vm.userid = vm.$route.query.userid
    }

    if (vm.$route.query.pkey) {
      vm.omise_key = vm.$route.query.pkey
    }

    if (vm.$route.query.sessiontoken) {
      vm.sessiontoken = vm.$route.query.sessiontoken
    }
    vm.pageLoading = true

    vm.pageid = vm.pageProfile.pageid

    if (vm.pageProfile.gbprime_status) {
      vm.transferType = 'qrcode'
    } else {
      vm.transferType = 'transfer'
    } /*  else {
      vm.transferType = "fbpay";
    } */

    document.title = vm.pageProfile.pagename
    vm.$store.dispatch('updateShopColor', vm.pageProfile.shopcolor)
    vm.pageLoading = false

    if (vm.userid) {
      try {
        let firstletterofuserid = vm.userid.charAt(0)
        if (firstletterofuserid && firstletterofuserid.toLowerCase() == 'u') {
          vm.app = 'line'
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }

      // var response_lang = await vm.$store.dispatch("getUserShopLang", {
      //   pageid: vm.pageProfile.pageid,
      //   userid: vm.userid,
      // });
      // if (response_lang) {
      //   vm.$store.dispatch("setLang", response_lang.usershoplang);
      // }
      vm.$store.dispatch('setLang', vm.pageProfile.shoplang)

      vm.getUserDetail().then(function (data) {
        vm.customerName = data.name
        vm.customerPhone = data.phone
        vm.shippingAddress = data.address
        vm.remark = data.remark
      })

      // var data = {
      //   userid: vm.userid,
      //   pageid: vm.pageProfile.pageid,
      //   lang: vm.currentLang
      // };
      // vm.$store.dispatch("setLang", vm.currentLang);
      // vm.$store.dispatch("updatePageProfile", data);
    }

    if (vm.$route.query.app) {
      vm.app = vm.$route.query.app
    }
    vm.$store
      .dispatch('getWholeSaleStatus', vm.pageProfile.pageid)
      .then(function () {
        vm.$store.dispatch('getWholeSale', vm.pageProfile.pageid)
      })
    await vm.getProducts()
    await vm.getUserCart()
    // await vm.getTransferDetail();

    var isCartOutOfStock =
      this.cart.filter(function (el) {
        if (el.optionDetail == null) {
          return true
        }
        if (parseInt(el.optionDetail[2]) < el.quantity) {
          return true
        }
        return false
      }).length > 0
    this.isCartOutOfStock = isCartOutOfStock
    if (isCartOutOfStock) {
      await this.$swal({
        title: this.$t('Not enough products in stock'),
        text: this.$t('Please try to order again or contact Admin'),
        type: 'warning',
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('Cancel'),
        reverseButtons: true
      })
      if (this.$liff.isInClient()) {
        // eslint-disable-next-line no-undef
        await this.$liff.sendMessages([
          {
            type: 'text',
            text:
              this.$t('Not enough products in stock') +
              ', ' +
              this.$t('Please try to order again or contact Admin')
          }
        ])
        // eslint-disable-next-line no-undef
        // await this.$liff.closeWindow();
      }
    }
    vm.loading = false
  },
  components: {
    SyncLoader,
    Loading,
    Modal,
    Cover,
    MerchantDetail,
    nl2br,
    UploadFile,
    TermAndCondition,
    CartItem,
    BankNumber,
    ShippingType,
    CartSummary
  },
  computed: {
    showOnlyQRpage() {
      return ['141179435910975'].includes(this.pageid)
    },
    ...mapGetters({
      cart: 'getCart',
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme'
    }),
    hasPaymentMethodMoreThanOne() {
      return (
        this.pageProfile.fbpay_status ||
        this.pageProfile.gbprime_status ||
        (this.shippinglist &&
          this.shippinglist.hasOwnProperty('cod_charge') &&
          this.shippinglist['cod_charge'][1])
      )
    },
    bearhouseshippingprice() {
      var zipcode = ''
      if (
        this.shippingAddress &&
        this.shippingAddress.match(/([1-9][0-9]{4})|^([1-9][0-9]{4})/g)
      ) {
        zipcode = this.shippingAddress
          .match(/([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/g)[0]
          .trim()
      }
      return bearhousecalculateshippingprice(zipcode, this.cart.length)
    },
    cdsshippingprice() {
      var zipcode = ''
      if (
        this.shippingAddress &&
        this.shippingAddress.match(/([1-9][0-9]{4})|^([1-9][0-9]{4})/g)
      ) {
        zipcode = this.shippingAddress
          .match(/([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/g)[0]
          .trim()
      }

      return cdsshippingprice(zipcode, this.totalincludediscount)
    },
    isBearhouse() {
      return (
        this.pageProfile &&
        this.$store.state.bearhouse.includes(this.pageProfile.pageid)
      )
    },
    isCDS() {
      return (
        this.pageProfile &&
        this.$store.state.cds.includes(this.pageProfile.pageid)
      )
    },
    isOoca() {
      return (
        this.pageProfile &&
        ['100935418246290', '142088386194745'].includes(this.pageProfile.pageid)
      )
    },
    pagename: function () {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined
    },
    totalPrice: function () {
      if (this.isBearhouse) {
        return this.totalincludediscount + this.bearhouseshippingprice
      } else if (this.isCDS) {
        return this.totalincludediscount + this.cdsshippingprice
      } else if (this.shippingType) {
        return this.totalincludediscount + this.shippingType.value
      } else {
        return this.totalincludediscount
      }
    }
  },
  methods: {
    async checkOrderStatus() {
      //   var total = numeral(0.01).format("0.00");
      var total = numeral(this.totalPrice).format('0.00')
      var response = await axios.get(
        config.getConfig('serverUrl') +
          `gbcompletedwithrefnoverify?referenceNo=${this.referenceNo}&pageid=${this.pageid}&userid=${this.userid}&amount=${total}`
      )
      return response
    },
    requestQrCode() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = new FormData()
        var total = numeral(vm.totalPrice).format('0.00')
        // var total = numeral(0.01).format("0.00");
        vm.referenceNo = moment().format('x')

        data.append(
          'token',
          vm.pageProfile.gbprime_token
          // "PUD9omECXQTwqePYfQzTS+S+lExcJJVNe3Ov0G2swnmSLml8MW3Ws6AKuvavsm5ydRzYSXuTFhyW1Q52EqXQUATUTsI+i1yCX7HDupxf7UEt3FBpQIKtTpo2bf0GetHO63MLQuHRsGk5cCe3H/Rw+NyC/7+HkSScuRlx5ikPosSJ9aeG"
        )
        data.append('amount', total)
        data.append('referenceNo', vm.referenceNo)
        data.append('detail', '-')
        data.append('customerName', vm.customerName)
        data.append(
          'backgroundUrl',
          `https://zwizai.herokuapp.com/gbcompletedcartwithrefno?referenceNo=${vm.referenceNo}&amount=${total}&userid=${vm.userid}&pageid=${vm.pageid}`
        )

        var xhr = new XMLHttpRequest()
        // xhr.withCredentials = true;

        xhr.addEventListener('readystatechange', function () {
          if (this.readyState === 4) {
            if (this.status == 200) {
              var arrayBuffer = this.response // Note: not oReq.responseText
              if (arrayBuffer) {
                resolve(new Uint8Array(arrayBuffer))
              } else {
                reject()
              }
              //
            } else {
              reject()
            }
          }
        })

        xhr.open('POST', 'https://api.gbprimepay.com/gbp/gateway/qrcode')
        xhr.responseType = 'arraybuffer'
        // xhr.setRequestHeader("Content-Type", "application/json");

        xhr.send(data)
      })
    },
    getByte(str) {
      var enc = new TextEncoder()
      return enc.encode(str)
    },
    requestQrCode2(photo) {
      // var vm = this;
      return new Promise((resolve, reject) => {
        if (photo) {
          // var photobyte = vm.getByte(photo);
          resolve(new Uint8Array(photo))
        } else {
          reject()
        }
      })
    },

    async submitOrder() {
      if (this.isEmptyShoppingCart) {
        return false
      }

      var total = this.total
      if (this.shippingType) {
        total += this.shippingType.value
      }
      let data = {
        amount: this.totalPrice.toFixed(2).toString().replace('.', ''),
        pageid: this.pageid,
        userid: this.userid,
        app: this.app,
        name: this.customerName,
        address: this.shippingAddress,
        phone: this.customerPhone,
        nameaddress:
          this.customerName +
          ' , ' +
          this.shippingAddress +
          ' , ' +
          this.customerPhone,
        shippingtype: this.shippingType ? this.shippingType.type : null,
        note: this.paymentSlipImage,
        remark: this.remark,
        payment: this.transferType == 'qrcode' ? 'qrcode' : null,
        shippingcharge: (this.shippingType ? this.shippingType.value : 0)
          .toFixed(2)
          .toString()
          .replace('.', ''),
        total: total.toFixed(2).toString().replace('.', '')
      }
      // central
      if (this.isCDS) {
        data.shippingtype = 'other_charge'
        data.shippingcharge = this.cdsshippingprice
          .toFixed(2)
          .toString()
          .replace('.', '')
        data.total = (this.total + this.cdsshippingprice)
          .toFixed(2)
          .toString()
          .replace('.', '')
      }

      //
      if (this.transferType == 'qrcode') {
        data.paiddate = moment()
        data.transactionid = this.referenceNo
      } else {
        data.paiddate = moment(`${this.paiddate} ${this.paidtime}`)
      }
      data.cart_ids = this.$store.state.cart_ids || []
      let url = config.getConfig('serverUrl') + 'banktransfernotify'
      if (this.sessiontoken != null || this.sessiontoken != '') {
        url += '?sessiontoken=' + this.sessiontoken
      }
      if (this.$route.query.from) {
        data.from = this.$route.query.from
      } else {
        try {
          var device = this.$liff.getOS()
          var version = this.$liff.getVersion()
          await this.$liff.ready

          if (
            this.userid.indexOf('__') != -1 &&
            device &&
            version &&
            !this.$liff.isInClient()
          ) {
            data.from = 'livechat'
          }
        } catch (error) {
          // eslint-disable-next-line
          console.log(error)
        }
      }

      try {
        var response = await axios.post(url, data)

        // JSON responses are automatically parsed.
        response = response.data
        if (response.responsecode == 200) {
          this.isCompleted = true
          await this.$store.dispatch('deleteAllItemsInCart')
          // eslint-disable-next-line
          if (this.$liff.isInClient()) {
            // eslint-disable-next-line no-undef
            await this.$liff.sendMessages([
              {
                type: 'text',
                text: 'Order: ' + response.orderid
              }
            ])
            // eslint-disable-next-line no-undef
            await this.$liff.closeWindow()
          } else {
            // eslint-disable-next-line no-undef
            MessengerExtensions.requestCloseBrowser(
              function success() {},
              function error() {
                window.close()
              }
            )
          }
        } else if (response.responsecode == 201) {
          this.isCompleted = true
          await this.$store.dispatch('deleteAllItemsInCart')
          let url = '/ecommerce/' + this.pagename
          if (this.userid && this.userid != null && this.userid != '') {
            url += '?userid=' + this.userid
          }
          this.$router.push({ path: url })
        } else {
          await this.$swal({
            title: this.$t('Error'),
            text: this.$t('Something went wrong. Please try it again.'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('Cancel'),
            reverseButtons: true
          })
        }
      } catch (error) {
        this.loading = false
        await this.$swal({
          title: this.$t('Error'),
          text: this.$t('Something went wrong. Please try it again.'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('Cancel'),
          reverseButtons: true
        })
      }
    },
    async closeQrCode() {
      // let result = await this.$swal({
      //   title: "คุณต้องการปิดหน้าต่างนี้ใช่มั้ย",
      //   text: "หากปิดหน้าต่างก่อนที่ระบบจะดำเนินการ การชำระเงินจะไม่สำเร็จ",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonText: this.$t("Confirm"),
      //   cancelButtonText: this.$t("Cancel"),
      //   reverseButtons: true
      // });
      // if (result.value)
      this.showQrCode = false
    },
    async getQrCode() {
      var result = await this.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        throw 400
      }

      try {
        var response = await this.requestQrCode()
        // console.log(response);
        var binary = response.reduce(
          (data, b) => (data += String.fromCharCode(b)),
          ''
        )
        this.qrimage = 'data:image/jpeg;base64,' + btoa(binary)
        var vm = this
        this.intervalQrCode = setInterval(async () => {
          vm.timer -= 1
          vm.isRequest = vm.timer % 5 == 0
          if (vm.timer == 0) {
            clearInterval(vm.intervalQrCode)
            await vm.$swal({
              title: vm.$t('Error'),
              text: vm.$t('Something went wrong. Please try it again.'),
              type: 'error',
              confirmButtonText: vm.$t('Confirm')
            })
            vm.showQrCode = false
            vm.timer = 300
          } else if (vm.timer % 5 == 0) {
            var response = await vm.checkOrderStatus()
            if (response.status == 200 && response.data.responsecode == 200) {
              if (response.data.data && response.data.data != null) {
                clearInterval(vm.intervalQrCode)

                vm.loading = true
                // console.log("submit");
                await vm.submitOrder()
                vm.loading = false

                vm.showQrCode = false
                vm.timer = 300
              }
            } else {
              clearInterval(vm.intervalQrCode)
              await vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t('Something went wrong. Please try it again.'),
                type: 'error',
                confirmButtonText: vm.$t('Confirm')
              })
              vm.showQrCode = false
              vm.timer = 300
            }
          }
        }, 1000)
      } catch (error) {
        throw error
      }
    },
    async getQrCode2() {
      var result = await this.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        throw 400
      }

      try {
        let photo = await this.gbcreaterefnofromcart()
        this.loadingQrcode = true
        var response = await this.requestQrCode2(photo)
        var binary = response.reduce(
          (data, b) => (data += String.fromCharCode(b)),
          ''
        )
        this.qrimage = 'data:image/jpeg;base64,' + btoa(binary)

        // var vm = this;
        // this.intervalQrCode = setInterval(async () => {
        //   vm.timer -= 1;
        //   vm.isRequest = vm.timer % 5 == 0;
        //   if (vm.timer == 0) {
        //     clearInterval(vm.intervalQrCode);
        //     await vm.$swal({
        //       title: vm.$t("Error"),
        //       text: vm.$t("Something went wrong. Please try it again."),
        //       type: "error",
        //       confirmButtonText: vm.$t("Confirm")
        //     });
        //     vm.showQrCode = false;
        //     vm.timer = 300;
        //   } else if (vm.timer % 5 == 0) {
        //     var response = await vm.checkOrderStatus();
        //     if (response.status == 200 && response.data.responsecode == 200) {
        //       if (response.data.data && response.data.data != null) {
        //         clearInterval(vm.intervalQrCode);

        //         vm.loading = true;
        //         // console.log("submit");
        //         await vm.submitOrder();
        //         vm.loading = false;

        //         vm.showQrCode = false;
        //         vm.timer = 300;
        //       }
        //     } else {
        //       clearInterval(vm.intervalQrCode);
        //       await vm.$swal({
        //         title: vm.$t("Error"),
        //         text: vm.$t("Something went wrong. Please try it again."),
        //         type: "error",
        //         confirmButtonText: vm.$t("Confirm")
        //       });
        //       vm.showQrCode = false;
        //       vm.timer = 300;
        //     }
        //   }
        // }, 1000);
      } catch (error) {
        throw error
      }
      this.loadingQrcode = false
    },
    async gbcreaterefnofromcart() {
      try {
        var total = this.total
        if (this.shippingType) {
          total += this.shippingType.value
        }
        var payment
        if (this.transferType) {
          payment = this.transferType
        } else {
          payment = null
        }
        let params = {}

        let detail = []
        this.cart.map((el) => {
          detail.push(
            `${el.name}${el.option ? ` (${el.option})` : ''} x ${el.quantity}`
          )
        })

        let stringdetail = detail.join(',')
        if (stringdetail.length < 250) {
          stringdetail.slice(0, 250)
        }

        let data = {
          detail: stringdetail,
          amount: this.totalPrice.toFixed(2).toString().replace('.', ''),
          pageid: this.pageid,
          userid: this.userid,
          app: this.app,
          name: this.customerName,
          address: this.shippingAddress,
          phone: this.customerPhone,
          payment: payment,

          nameaddress:
            this.customerName +
            ' , ' +
            this.shippingAddress +
            ' , ' +
            this.customerPhone,
          shippingtype: this.shippingType ? this.shippingType.type : null,
          note: this.paymentSlipImage,
          remark: this.remark,
          shippingcharge: (this.shippingType ? this.shippingType.value : 0)
            .toFixed(2)
            .toString()
            .replace('.', ''),
          total: total.toFixed(2).toString().replace('.', '')
        }
        if (this.isBearhouse) {
          data.shippingtype = 'other_charge'
          data.shippingcharge = this.bearhouseshippingprice
            .toFixed(2)
            .toString()
            .replace('.', '')
          data.total = (this.total + this.bearhouseshippingprice)
            .toFixed(2)
            .toString()
            .replace('.', '')
        }

        if (this.isCDS) {
          data.shippingtype = 'other_charge'
          data.shippingcharge = this.cdsshippingprice
            .toFixed(2)
            .toString()
            .replace('.', '')
          data.total = (this.total + this.cdsshippingprice)
            .toFixed(2)
            .toString()
            .replace('.', '')
        }

        if (this.sessiontoken != null || this.sessiontoken != '') {
          data.sessiontoken = this.sessiontoken
        }

        // {
        // 	refno: ...,
        // 	amount: ...
        // }
        if (this.$route.query.from) {
          data.from = this.$route.query.from
        } else {
          try {
            var device = this.$liff.getOS()
            var version = this.$liff.getVersion()
            await this.$liff.ready

            if (
              this.userid.indexOf('__') != -1 &&
              device &&
              version &&
              !this.$liff.isInClient()
            ) {
              data.from = 'livechat'
            }
          } catch (error) {
            // eslint-disable-next-line
            console.log(error)
          }
        }

        let response = await axios.post(
          config.getConfig('serverUrl') + 'gbcreaterefnofromcart',
          data,
          {
            params: params,
            headers: { AUTHORIZATION: 'Bearer xxx xxx' },
            responseType: 'arraybuffer'
          }
        )
        // console.log(response);

        if (response.status == 200) {
          // console.log(response.data);
          return response.data
        } else {
          throw 400
        }

        // if (response.data.responsecode == 200) {
        //   let res = response.data.data;
        //   console.log(res);

        //   return res;
        // } else {
        //   throw response.data.responsecode;
        // }
      } catch (error) {
        throw error
      }
    },
    getUserDetail: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'lastorderaddress?pageid=' +
              vm.pageid +
              '&userid=' +
              vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              if (response.data) {
                resolve(response.data)
              } else {
                reject()
              }
            } else {
              reject()
              // console.log(response);
            }
          })
      })
    },
    openModal: function () {
      this.showTerm = true
      let vm = this
      window.location.hash = '#modal-open'
      window.onpopstate = function () {
        if (location.hash == '#modal-open') {
          //   console.log("test");
        } else {
          vm.showTerm = false
        }
      }
    },
    close: function () {
      var vm = this
      if (window.history.length == 0) {
        vm.showTerm = false
      } else {
        window.history.back()
      }
    },
    getTransferDetail: async function () {
      let vm = this
      var response = await axios.get(
        config.getConfig('serverUrl') + 'banktransferinfo?pageid=' + vm.pageid
      )
      // JSON responses are automatically parsed.
      response = response.data
      if (response.responsecode == 200) {
        vm.banktransferinfo = response.banktransferinfo
        vm.banktransferinfo_photo = response.banktransferinfo_photo
      } else {
        //
      }
    },
    async qrHandleSubmit() {
      try {
        await this.getQrCode2()
        // if (this.pageid == "361231620965547") {
        // } else {
        //   await this.getQrCode();
        // }
        this.showQrCode = true
      } catch (error) {
        // console.log(error);
      }
    },
    handleSubmit: function () {
      let vm = this
      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.isEmptyShoppingCart) {
          return false
        }
        vm.loading = true
        var total = vm.total
        if (vm.shippingType) {
          total += vm.shippingType.value
        }
        var payment
        if (vm.transferType) {
          payment = vm.transferType
        } else {
          payment = null
        }
        let data = {
          amount: vm.totalPrice.toFixed(2).toString().replace('.', ''),
          pageid: vm.pageid,
          userid: vm.userid,
          app: vm.app,
          name: vm.customerName,
          address: vm.shippingAddress,
          phone: vm.customerPhone,
          payment: payment,
          nameaddress:
            vm.customerName +
            ' , ' +
            vm.shippingAddress +
            ' , ' +
            vm.customerPhone,
          shippingtype: vm.shippingType ? vm.shippingType.type : null,
          note: vm.paymentSlipImage,
          remark: vm.remark,
          shippingcharge: (vm.shippingType ? vm.shippingType.value : 0)
            .toFixed(2)
            .toString()
            .replace('.', ''),
          total: total.toFixed(2).toString().replace('.', '')
        }
        if (this.isBearhouse) {
          data.shippingtype = 'other_charge'
          data.shippingcharge = vm.bearhouseshippingprice
            .toFixed(2)
            .toString()
            .replace('.', '')
          data.total = (vm.total + vm.bearhouseshippingprice)
            .toFixed(2)
            .toString()
            .replace('.', '')
        }
        // central
        if (this.isCDS) {
          data.shippingtype = 'other_charge'
          data.shippingcharge = this.cdsshippingprice
            .toFixed(2)
            .toString()
            .replace('.', '')
          data.total = (this.total + this.cdsshippingprice)
            .toFixed(2)
            .toString()
            .replace('.', '')
        }
        data.cart_ids = this.$store.state.cart_ids || []

        let url = config.getConfig('serverUrl') + 'banktransfernotify'
        if (vm.sessiontoken != null || vm.sessiontoken != '') {
          url += '?sessiontoken=' + vm.sessiontoken
        }

        if (vm.$route.query.from) {
          data.from = vm.$route.query.from
        } else {
          try {
            var device = vm.$liff.getOS()
            var version = vm.$liff.getVersion()
            vm.$liff.ready.then(() => {
              if (
                vm.userid.indexOf('__') != -1 &&
                device &&
                version &&
                !vm.$liff.isInClient()
              ) {
                data.from = 'livechat'
              }
            })
          } catch (error) {
            // eslint-disable-next-line
            console.log(error)
          }
        }

        axios
          .post(url, data)
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.isCompleted = true
              vm.$store.dispatch('deleteAllItemsInCart')
              // eslint-disable-next-line
              if (vm.$liff.isInClient()) {
                // eslint-disable-next-line no-undef
                vm.$liff
                  .sendMessages([
                    {
                      type: 'text',
                      text: 'Order: ' + response.orderid
                    }
                  ])
                  .then(() => {})
                // eslint-disable-next-line no-undef
                vm.$liff.closeWindow()
              } else {
                // eslint-disable-next-line no-undef
                MessengerExtensions.requestCloseBrowser(
                  function success() {},
                  function error() {
                    window.close()
                  }
                )
              }
            } else if (response.responsecode == 400) {
              vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t(response.reason),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('Cancel'),
                reverseButtons: true
              })
            } else if (response.responsecode == 201) {
              vm.isCompleted = true
              vm.$store.dispatch('deleteAllItemsInCart')
              let url = '/ecommerce/' + vm.pagename
              if (vm.userid && vm.userid != null && vm.userid != '') {
                url += '?userid=' + vm.userid
              }
              vm.$router.push({ path: url })
            } else {
              vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t('Something went wrong. Please try it again.'),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('Cancel'),
                reverseButtons: true
              })
            }
            vm.loading = false
          })
          .catch(() => {
            vm.loading = false
            vm.$swal({
              title: vm.$t('Error'),
              text: vm.$t('Something went wrong. Please try it again.'),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('Cancel'),
              reverseButtons: true
            })
          })
      })
    },

    getUserCart: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'usercart?pageid=' +
              vm.pageid +
              '&userid=' +
              vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.banktransferinfo = response.banktransferinfo
              vm.banktransferinfo_photo = response.banktransferinfo_photo
              // vm.$store.dispatch('setCart',response.cartarray)
              vm.$store.commit('SET_CART_ID', response.cart_ids || [])
              if (response.cartarray) {
                if (response.cartarray.length == 0) {
                  vm.isEmptyShoppingCart = true
                } else {
                  vm.isEmptyShoppingCart = false
                }
                var product_id_list = []
                var products = []

                $.each(response.cartarray, function (index, val) {
                  product_id_list.push(val.productid)

                  if (vm.products[val.productid]) {
                    var stock = vm.products[val.productid].productstock
                    var option = stock.find(function (el) {
                      return el[1] == val.option
                    })
                  }
                  products.push({
                    photourl: val.photourl,
                    quantity: val.quantity,
                    name: val.name,
                    option: val.option,
                    id: val.productid,
                    price: parseFloat(val.price),
                    discountprice: parseFloat(val.discountprice),
                    optionDetail: option,
                    categoryid: val.categoryid,
                    cart_remark: val.cart_remark
                  })
                })

                if (products.length > 0) {
                  for (let index = 0; index < products.length; index++) {
                    vm.$store.dispatch('addToCart', {
                      product: products[index]
                    })
                  }

                  let url =
                    config.getConfig('serverUrl') +
                    'productbundle?productid=' +
                    product_id_list.join(',')
                  axios.get(url).then((response) => {
                    response = response.data
                    if (
                      response.responsecode == 200 &&
                      response.productbundlelist.length > 0
                    ) {
                      vm.$store.commit(
                        'UPDATE_BUNDLE_CART',
                        response.productbundlelist
                      )
                    }
                  })
                }

                vm.additionalproduct_charge = parseFloat(
                  response.additionalproduct_charge
                )
                vm.ems_charge = parseFloat(response.ems_charge)
                vm.normal_charge = parseFloat(response.normal_charge)
                vm.kerry_charge = parseFloat(response.kerry_charge)
                vm.total = parseFloat(response.total)
                vm.totalincludediscount = parseFloat(
                  response.totalincludediscount
                )
                vm.discount = parseFloat(response.discount)

                vm.shippinglist = response.shippinglist
              }
              resolve()
            } else {
              // console.log(response);
              reject()
            }
          })
      })
    },
    goToShop: function () {
      let vm = this
      let url = '/ecommerce/' + vm.pagename
      if (vm.userid && vm.userid != null && vm.userid != '') {
        url += '?userid=' + vm.userid
        if (
          vm.sessiontoken &&
          vm.sessiontoken != null &&
          vm.sessiontoken != ''
        ) {
          url += '&sessiontoken=' + vm.sessiontoken
        }
      }
      vm.$router.push({ path: url })
    },
    getProducts: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageid
        }
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.pageProfile.ketshop_api_key
          data['ketshop_api_secret'] = vm.pageProfile.ketshop_api_secret
        }
        axios
          .get(config.getConfig('serverUrl') + 'products', {
            params: data
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.products = {}
              var products = response.productlist.filter((el) => {
                // console.log(el.status);
                return el.status == true
              })
              $.each(products, function (index, val) {
                products[index].price = parseFloat(products[index].price)
                products[index].discountprice = parseFloat(
                  products[index].discountprice
                )
                products[index].isOutOfStock = false

                if (products[index].productstock.length > 0) {
                  var haveStock = false
                  $.each(val.productstock, function (pindex, pval) {
                    if (parseInt(products[index].productstock[pindex][2]) > 0) {
                      haveStock = true
                    }

                    var price = 0
                    var discount = 0

                    if (pval[3] == null && pval[4] == null) {
                      price = parseFloat(val.price)
                      discount = parseFloat(val.discountprice)
                    } else {
                      if (pval[3] == null) {
                        price = parseFloat(val.price)
                      } else {
                        price = parseFloat(
                          products[index].productstock[pindex][3]
                        )
                      }

                      if (pval[4] == null) {
                        discount = products[index].productstock[pindex][3]
                      } else {
                        discount = parseFloat(
                          products[index].productstock[pindex][4]
                        )
                      }
                    }

                    products[index].productstock[pindex][3] = price

                    products[index].productstock[pindex][4] = discount
                  })

                  if (!haveStock) {
                    products[index].isOutOfStock = true
                  }
                } else {
                  products[index].isOutOfStock = true
                }
                if (val) {
                  vm.products[val.id] = val
                }
              })

              resolve()
            } else {
              // console.log(response);
              reject()
            }
          })
      })
    }
  }
}
</script>
